const options = {
  5: "bg-rose-900/5",
  10: "bg-rose-900/10",
  25: "bg-rose-900/25",
  50: "bg-rose-900/50",
  75: "bg-rose-900/75",
  90: "bg-rose-900/90",
  100: "bg-rose-900",
};

const from = {
  5: "from-rose-900/5",
  10: "from-rose-900/10",
  25: "from-rose-900/25",
  50: "from-rose-900/50",
  75: "from-rose-900/75",
  90: "from-rose-900/90",
  100: "from-rose-900",
};

export default function getBackgroundRose900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
